// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingContainer-NsetG{display:flex;align-items:center;justify-content:center;height:100%;min-height:inherit}`, "",{"version":3,"sources":["webpack://./src/components/common/Loading/loading.module.scss"],"names":[],"mappings":"AAAA,wBACI,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,WAAA,CACA,kBAAA","sourcesContent":[".loadingContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    min-height: inherit;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `loadingContainer-NsetG`
};
export default ___CSS_LOADER_EXPORT___;
